function enviaApi(api,method,body,token){
	fetch("https://cursoecografiavinno.com/tienda/wp-json/"+api,
		{
			method: method,
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				"Authorization":"Bearer "+token,
			},
			body: body
		})
		.then(response => response.json())
		.then(data => console.log(data));
}

export { enviaApi };